import type {SharedData} from '@gaia/types';
import fetchJSON from '@gaia/utils/fetchJSON';
import formatRemoteFolder from '@gaia/utils/gaia/formatRemoteFolder';
import {registerSavedFolder} from '@gaia/utils/gaia/saveFolder';

export default function takeLocal(
    action: TakeFolderLocalAction,
    folders: {[localId: string]: Folder},
    setFolders: React.Dispatch<React.SetStateAction<{[localId: string]: Folder}>>,
    sharedData: SharedData
) {
    const folder = action.folder;
    const {id, localId} = folder;

    if (localId && folders[localId]) {
        if (action.callback) action.callback(folders[localId]);
        return [localId];
    }

    if (id && folders[id]) {
        if (action.callback) action.callback(folders[id]);
        return [id];
    }

    if (!id) throw new Error('Cannot call takeLocal on a folder without an id');

    const initialFolder: Folder = {
        title: '',
        notes: '',
        time_created: new Date().toISOString(),
        updated_date: new Date().toISOString(),
        ...folder,
        id,
        localId: id,
        type: 'folder',
    };

    registerSavedFolder(initialFolder);

    const pubLink =
        sharedData && sharedData.type === 'folder' && sharedData.pubLink
            ? `?pubLink=${sharedData.pubLink}`
            : '';

    fetchJSON(`/api/objects/folder/${folder.id}/summary/${pubLink}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
    })
        .then((remoteFolder) => {
            setFolders((latestFolders) => {
                const latestFolder: Folder = {
                    ...initialFolder,
                    ...formatRemoteFolder(remoteFolder),
                };
                registerSavedFolder(latestFolder);
                if (action.callback) action.callback(latestFolder);

                return {
                    ...latestFolders,
                    [id]: latestFolder,
                };
            });
        })
        .catch(console.warn);

    return [id];
}
